import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import BeeEditorView from './bee-editor.component.html';
import { MailingsService } from '../../services/mailings.service';
import BeefreeSDK from '@beefree.io/sdk';
import { IToken } from '@beefree.io/sdk/dist/types/bee';
import { LogService } from '../../../core/services/log.service';

@Component({
  selector: 'bee-editor',
  template: BeeEditorView,
  styles: `
    .editor-container {
      width: 90%;
      margin: 20px auto;
      border: 1px solid #ddd;
      border-radius: 8px;
      height: 800px;
    }
  `
})
export class BeeEditorComponent implements OnInit {
  @Input() public template: object = {};
  @ViewChild('editorContainer', { static: true }) 
  editorContainer!: ElementRef;
  bee: BeefreeSDK;
    config_email = {
      client_id: "958cfa50-f6d0-470f-bdfa-34ab8a4862fa", // Enter your client id
      client_secret: "a3pX7dmiSzlvRLDge4Qc6wqBqZ5KnDT99ghuzHvqprRDWSQwilQf", // Enter your secret key
      grant_type: "password" // Do not change
  };


  constructor(@Inject(MailingsService) private mailingsService: MailingsService,
              @Inject(LogService) private logService: LogService) { }

  async ngOnInit() {
    try {
      this.mailingsService.BeeLogin().subscribe(token => {
          this.init(token);
      });

      this.init(undefined); // Temporarily passing undefined, replace with actual token retrieval logic
      
    } catch (error) {
      console.error('Beefree initialization failed:', error);
    }
  }

  private async init(token: IToken) {
    console.debug(token);
    if(token === undefined || token === null) {
      return;
    }
      this.bee = new BeefreeSDK(token);

/*      this.bee.UNSAFE_getToken(
        this.config_email.client_id,
        this.config_email.client_secret,
        'stela-5EF29E35-3DEC-4B2C-B492-2D8543798F01'
      ).then(() => {*/
         let result = await this.bee.start(
          {
            container: 'beefree-container',
            language: 'es-ES',
            onSave: (jsonFile, htmlFile) => {
              console.log('Content saved:', jsonFile, htmlFile);
            },
            onError: (error) => {
              console.error('Beefree error:', error);
            },
            onWarning: (warning) => {
              console.warn('Beefree warning:', warning);
            }
          },
          this.template
        );
        console.log('Beefree started with result:', result);
  }

}
